import { Button, DatePicker, Form, Select } from "antd";
import axios from "axios";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { authenticateToken } from "../../utils/auth";
import Loading from "../common/Loader";
import Empty from "../common/Empty";
import moment from "moment";
import TopHeading from "./TopHeading";
import { debounce } from "lodash";
import { OrderTypeArray } from "../../utils";
const { RangePicker } = DatePicker;
const { Option } = Select;

const SalesReportList = () => {
  const [form] = Form.useForm();
  const [type, setType] = useState("JC_MART");
  const [hubId, setHubId] = useState<any>();
  const [status, setStatus] = useState<any>();

  const [range, setRange] = useState({
    from: null,
    to: null,
  });

  const [salesData, setSalesData] = useState({
    loading: false,
    data: null,
  });

  const [downloadData, setDownloadData] = useState({
    loading: false,
    data: null,
  });

  const [hubOptions, setHubOptions] = useState({
    loading: false,
    list: [],
  });

  const getSalesReport = useCallback(async () => {
    const from = moment(range.from)?.toISOString();
    const to = moment(range.to)?.toISOString();

    setSalesData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_ORDER_API}`;
    axios
      .get(
        `${encodedUri}/finance/sales` +
          (from ? `?fromDate=${from}` : ``) +
          (to ? `&toDate=${to}` : ``) +
          (hubId ? `&hubId=${hubId}` : ``) +
          (status ? `&status=${status}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setSalesData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setSalesData({ loading: false, data: [] });
        console.error("Data: Error", err);
      });
  }, [hubId, range.from, range.to, status]);

  const getSalesReportDownload = useCallback(async () => {
    const from = moment(range.from)?.toISOString();
    const to = moment(range.to)?.toISOString();

    setDownloadData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_ORDER_API}`;
    fetch(
      `${encodedUri}/finance/sales/download?page=0` +
        (from ? `&fromDate=${from}` : ``) +
        (to ? `&toDate=${to}` : ``) +
        (hubId ? `&hubId=${hubId}` : ``) +
        (status ? `&status=${status}` : ``),
      {
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
        },
      }
    )
      .then((response) => {
        return response.blob();
      })
      .then((res) => {
        setDownloadData({ loading: false, data: res });
        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Sales_Report-${moment(range.from).format("YYYY_MM_DD")}-${moment(
            range.to
          ).format("YYYY_MM_DD")}.xlsx`
        );
        link.click();
      })
      .catch((err) => {
        console.error("Data: Error", err);
      });
  }, [hubId, range.from, range.to, status]);

  const getHubOptions = useCallback(
    async (key) => {
      setHubOptions({ loading: true, list: null });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
      return axios
        .get(
          `${encodedUri}/hub/search?page=0&limit=20` +
            (key ? `&name=${key}` : ``) +
            (type ? `&type=${type}` : ``),
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        )
        .then((res) => {
          setHubOptions({
            loading: false,
            list: res.data?.hub?.map((hub) => ({
              value: hub.id,
              label: hub.name,
            })),
          });
        })
        .catch((err) => {
          setHubOptions({ loading: false, list: [] });
          console.error("Hubs: Error", err);
        });
    },
    [type]
  );

  const fetchRef = useRef(null);
  const handleSearch = React.useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      if (value) {
        if (field === "hub") getHubOptions(value);
      }
    };

    return debounce(loadOptions, 800);
  }, [getHubOptions]);

  useEffect(() => {
    getHubOptions("");
    getSalesReport();
  }, [getSalesReport, getHubOptions]);

  const reseAllFieldData = () => {
    form.resetFields();
    setHubId("");
    setStatus("");
    setRange({
      from: null,
      to: null,
    });
  };

  const paymentMethods = useMemo(() => {
    let allPayments = {};

    salesData?.data?.sales?.find((shop) => {
      if (shop?.methodAmount?.length > 0) {
        shop?.methodAmount.forEach((method) => {
          allPayments[method?.paymentMethod] = 1;
        });
      }
    });
    return Object.keys(allPayments);
  }, [salesData]);

  const formatedData = useMemo(() => {
    const obj = {};
    salesData?.data?.sales?.map((shop) => {
      const method = {};
      shop?.methodAmount?.map((item) => {
        method[item?.paymentMethod] = item?.total;
      });
      obj[shop?.shopName] = method;
    });
    return obj;
  }, [salesData]);

  const totalData = useMemo(() => {
    return (
      salesData?.data?.sales?.reduce((obj, data) => {
        const newObj = {};
        console.log(1, obj, data?.methodAmount);

        data?.methodAmount?.map((item) => {
          newObj[item?.paymentMethod] =
            (obj[item?.paymentMethod] || 0) + (item?.total || 0);
        });

        const onlyMethods = { ...obj, ...newObj };
        let allMethodsTotal = 0;
        Object.keys(onlyMethods)?.forEach((item) => {
          if (item !== "total") {
            allMethodsTotal += onlyMethods?.[item];
          }
        });

        return {
          ...onlyMethods,
          total: allMethodsTotal,
        };
      }, {}) || {}
    );
  }, [salesData]);

  const handleChangeStatus = (value: string) => {
    setStatus(value);
  };

  return (
    <React.Fragment>
      <TopHeading
        {...salesData?.data?.totalElements}
        refetch={getSalesReport}
        title={"Sales Report"}
        download={() => getSalesReportDownload()}
        dissable={!salesData?.data?.sales?.length ? true : false}
        loading={downloadData?.loading}
      />
      <section className="search_area">
        <Form form={form} className="search_form">
          <Form.Item name="range">
            <RangePicker
              onChange={(f) => {
                setRange({ from: f?.[0], to: f?.[1] });
              }}
              showTime={{
                hideDisabledOptions: true,
                defaultValue: [
                  moment("00:00:00", "HH:mm:ss"),
                  moment("23:59:59", "HH:mm:ss"),
                ],
              }}
              inputReadOnly
              allowClear
            />
          </Form.Item>

          <Form.Item name="hub_search" initialValue={hubId}>
            <Select
              allowClear
              showSearch
              placeholder="Filter by Hub"
              optionFilterProp="children"
              onChange={(val) => setHubId(val)}
              onSearch={(e) => handleSearch(e, "hub")}
              filterOption={(input, option) =>
                option.children
                  .toString()
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              // options={hubOptions?.list}
            >
              {hubOptions?.list?.length ? (
                <Option value="">All Hubs</Option>
              ) : undefined}
              {hubOptions?.list?.map((hub) => (
                <Option value={hub?.value}>{hub?.label}</Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="status_search" initialValue={status}>
            <Select
              showSearch
              placeholder="Filter by Status"
              onChange={handleChangeStatus}
            >
              <Select.Option value="">ALL STATUS</Select.Option>
              {Object.values(OrderTypeArray)?.map((type, i) => (
                <Select.Option value={type} key={i}>
                  {type?.split("_").join(" ")}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Form>

        <div className="search_btn">
          <Button type="primary" danger size="large" onClick={reseAllFieldData}>
            Reset
          </Button>
        </div>
      </section>
      <section className="product-list-item-area white-bg section-padding-bottom">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-list-items-inner-content">
                <div className="single-product-wrapper">
                  <div className="single-product-heading">
                    <span>Shop Name</span>
                  </div>
                  {paymentMethods.map((pm) => (
                    <div className="single-product-heading">
                      <span>{pm?.replace("_", " ")}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {salesData?.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12 product-table">
                <div className="product-table-area">
                  {salesData?.data?.sales?.length ? (
                    salesData?.data?.sales?.map(
                      (salesData: any, index: any) => (
                        <React.Fragment key={index}>
                          <div className="single-product-wrapper">
                            <div className="single-product">
                              <span className="name">
                                {salesData?.shopName}
                              </span>
                            </div>
                            {paymentMethods?.map((pm) => {
                              return (
                                <div className="single-product">
                                  <span className="name">
                                    {formatedData[salesData?.shopName][pm] || 0}
                                  </span>
                                </div>
                              );
                            })}
                          </div>
                        </React.Fragment>
                      )
                    )
                  ) : (
                    <Empty data="Data" />
                  )}
                </div>
              </div>
            )}
          </div>
          <div className="row">
            {salesData?.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12">
                <div className="product-table-area ">
                  <div className="single-product-wrapper">
                    <div className="single-product">
                      <b className="name font-weight-bold">
                        Total (&#2547;{totalData["total"] || 0})
                      </b>
                    </div>
                    {paymentMethods?.map((pm) => {
                      return (
                        <div className="single-product">
                          <span className="name font-weight-bold">
                            &#2547;{totalData[pm] || 0}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default SalesReportList;
